import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=3ab852ae&scoped=true"
import script from "./BaseToggle.vue?vue&type=script&lang=ts"
export * from "./BaseToggle.vue?vue&type=script&lang=ts"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&id=3ab852ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab852ae",
  null
  
)

export default component.exports